








































































import { Vue, Component } from "vue-property-decorator"
import EnneagramSvg from "../assets/enneagram/Enneagram.svg"
import AppFooter from "./AppFooter.vue"

@Component({
  components: {
    EnneagramSvg,
    AppFooter,
  },
})
export default class IntroText extends Vue {
  public onSwipeLeft() {
    this.$router.push("/enneagram")
  }
}
